var carouselBig = $('.cdk-product_image').owlCarousel({
  // options
  loop: true,
  margin: 10,
  nav: true,
  items: 1,
  center: true,
  dots: false,
  lazyLoad: true,
  lazyLoadEager: 1,
  autoHeight: true,
  stagePadding: 70,
  navText: ["<i class='fa fa-long-arrow-left'></i>", "<i class='fa fa-long-arrow-right'></i>"],
  responsive: {
    // breakpoint from 768 up
    768: {
      center: false,
      stagePadding: 0,
    }
  },
});

var carouselnav = $('.cdk-product_nav').owlCarousel({
  // options
  loop: false,
  margin: 15,
  nav: false,
  items: 4,
  center: false,
  dots: false,
});

$('.cdk-product_nav .cdk-product_nav-item').on('click', function () {
  var nav_index = $(this).attr('forloop-index');
  carouselBig.trigger('to.owl.carousel', nav_index);
});

$('.product-form select.single-option-selector').on('change', function () {
  var img_index = $(this).find('option:selected').attr('data-image-value');
  $(".cdk-product_nav .cdk-product_nav-item.nav-item_cdk--" + img_index).click();
});

function reChargeProcessCart(isSubscribeProductExist) {
  var disCountValue = $('.mini--cart--form-z11 input[name="discount"]').val();
  if (disCountValue == '' || disCountValue == undefined) {
    var disCountValue = '';
  }

  function get_cookie(name) {
    return (document.cookie.match('(^|; )' + name + '=([^;]*)') || 0)[2]
  }
  do {
    var token = get_cookie('cart');
  }
  while (token == undefined);

  var myshopify_domain = 'missfits-shop.myshopify.com';
  try {
    var ga_linker = ga.getAll()[0].get('linkerParam')
  } catch (err) {
    var ga_linker = ''
  }
  var customer_param = window.customer_param;
  var checkout_url = "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=" + myshopify_domain + "&cart_token=" + token + "&" + ga_linker + "&" + customer_param;

  $('.cart-popup-wrapper form table tbody tr').each(function () {
    var title = $.trim($(this).attr('data-cart-item-title'));
    if (title.indexOf('Auto renew') > -1) {
      isSubscribeProductExist = 'YES';
    }
  })
  if (isSubscribeProductExist == 'YES') {
    window.location.href = checkout_url;
  } else {
    if (disCountValue != '' || disCountValue != 'undefined') {
      window.location.href = '/checkout?discount=' + disCountValue;
    } else {
      window.location.href = '/checkout';
    }

  }

}

function redirectToCart() {
  window.location.href = '/cart';
  return false;
}

function updateMiniCartContents(btnText) {

  //ajax get request to cart.js
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function (data) {
      var cartCount = data.item_count;
      $('.site-header__icons-wrapper .site-header__cart #CartCount span.data_cart__count').text(cartCount);

      if (cartCount == 0) {
        $('.site-header__icons-wrapper .site-header__cart #CartCount').addClass('hide');
        $('.cart-popup-wrapper #hide--container-10').addClass('hide');
        $('.cart-popup-wrapper .empty-page-content').removeClass('hide');
      } else {
        $('.cart-popup-wrapper #hide--container-10').removeClass('hide');
        $('.cart-popup-wrapper .empty-page-content').addClass('hide');
        $('.site-header__icons-wrapper .site-header__cart #CartCount').removeClass('hide');
      }

      // for product page
      $('form .subscription--product-addtocart').text(btnText);
      $('form .subscription--product-addtocart').removeClass("make--me-untoucable");

      window.setTimeout(function () {
        redirectToCart();
      }, 1000);
    }
  });
}

function update_minicart(variantId, btnText) {
  $.ajax({
    type: "GET",
    url: '/',
    success: function (response) {
      var totalCount = parseInt($(response).find('#CartPopupHeading').attr('data-count'));
      if (totalCount == 0) {
        $('.site-header__icons-wrapper .site-header__cart #CartCount').addClass('hide');
        $('.cart-popup-wrapper #hide--container-10').addClass('hide');
        $('.cart-popup-wrapper .empty-page-content').removeClass('hide');
      } else {
        $('.cart-popup-wrapper #hide--container-10').removeClass('hide');
        $('.cart-popup-wrapper .empty-page-content').addClass('hide');
        $('.site-header__icons-wrapper .site-header__cart #CartCount').removeClass('hide');
      }

      $(response).find('.cart-popup-wrapper').find('.BunQuanBox').html();
      $('.site-header__icons-wrapper .site-header__cart #CartCount span.data_cart__count').text(totalCount);
      $('.cart-popup-wrapper').removeClass('cart-popup-wrapper--hidden');
      $('#shopify-section-cart-popup-new .cart-popup-wrapper').LoadingOverlay("hide");
      var minicartHtml = $(response).find('.mini--cart--form-z11').html();

      var cartPopupHeadingHtml = $(response).find('#CartPopupHeading').text();
      var cartTextNote = $(response).find('.cart-popup-wrapper').find('.BunQuanBox').html();

      $('#shopify-section-cart-popup-new .cart-popup-wrapper .BunQuanBox').html(cartTextNote);
      $('.product-template__container .BunQuanBox').html(cartTextNote);

      $('#shopify-section-cart-popup-new .cart-popup-wrapper #CartPopupHeading').html(cartPopupHeadingHtml);
      $('#shopify-section-cart-popup-new .cart-popup-wrapper .mini--cart--form-z11').html(minicartHtml);

      if (variantId != '') {
        $('.cdk_product-item a[data-varient-id="' + variantId + '"]').text(btnText);
        $('.cdk_product-item a[data-varient-id="' + variantId + '"]').removeClass("make--me-untoucable");
        // for product page
        $('form .subscription--product-addtocart').text(btnText);
        $('form .subscription--product-addtocart').removeClass("make--me-untoucable");
      }
    }
  });
}

function ajaxAddToCart(id, quantity) {
  var dynamicData = "quantity=" + quantity + "&id=" + id;
  return $.ajax({
    url: "/cart/add.js",
    type: "get",
    data: dynamicData,
    dataType: "json",
    beforeSend: function () {
    },
    error: function (jqXHR, textStatus, errorThrown) {
      if (jqXHR.status == 400) {
        alert(jqXHR.responseJSON.message);
      }
    }
  });
}

function cd_ajaxAddToCart(id, quantity) {
  var dynamicData = "quantity=" + quantity + "&id=" + id;
  return $.ajax({
    url: "/cart/add.js",
    type: "get",
    data: dynamicData,
    dataType: "json",
    beforeSend: function () {
    },
    error: function (jqXHR, textStatus, errorThrown) {
      if (jqXHR.status == 400) {
        alert(jqXHR.responseJSON.message);
      }
    }
  });
}

function subscriptionAjaxAddToCart(data, currentThis, redirectToCheckout) {

  $.ajax({
    url: "/cart/add.js",
    type: "POST",
    data: {
      items: data
    },
    dataType: "json",
    success: function (data) {
      // currentThis.text("Add to cart"); currentThis.removeClass("make--me-untoucable");
      var productTitle = '';
      var isSubscribeProductExist = '';
      if (data.items.length > 0) {
        productTitle = data.items[0].title;
      }
      console.log('productTitle :: ' + productTitle);
      var btnText = "Add to cart";
      var variantId = 'subscription';
      if (redirectToCheckout == 'true') {
        if (productTitle.indexOf('Auto renew') > -1) {
          isSubscribeProductExist = 'YES';
          reChargeProcessCart(isSubscribeProductExist);
        }

      } else {
        //update_minicart(variantId,btnText); 
        updateMiniCartContents(btnText);
      }

    },
    error: function (jqXHR, textStatus, errorThrown) {
      currentThis.text("Add to cart");
      currentThis.removeClass("make--me-untoucable");
      if (jqXHR.status == 400) {
        alert(jqXHR.responseJSON.message);
      }
      if (jqXHR.status == 422) {
        alert(jqXHR.responseJSON.description);
      }
    }
  });
}
//Ajax Add To Cart Function End 

$(document).on("click", ".add-to_cart--product-11", function (p) {
  p.preventDefault();
  var currentThis = $(this);
  currentThis.text("Please wait...");
  currentThis.addClass("make--me-untoucable");
  var quantity = parseInt($(this).attr('data-item-quantity')),
    id = $(this).attr('data-varient-id');
  var variantId = id;
  ajaxAddToCart(id, quantity).done(function (data) {
    var btnText = "ADD TO CART";
    updateMiniCartContents(btnText);
  });
});

$(document).on("click", "form .subscription--product-addtocart", function (p) {
  p.preventDefault();
  var currentThis = $(this);
  currentThis.text("Please wait...");
  currentThis.addClass("make--me-untoucable");
  var quantity = parseInt($('.product-form__item .quantityInput #Quantity-cdk-product-template').val());
  var items = [];
  var redirectToCheckout = '';
  var shipping__interval_unittype_value = $('#rc_container input[name="properties[shipping_interval_unit_type]"]').val();
  var shipping_interval_frequency_value = $('#rc_container  select[name="properties[shipping_interval_frequency]"]').val();

  if ($('#rc_radio_options .rc_radio__onetime').is(":checked") || $('#rc_radio_options .rc_radio__onetime').length == 0) {
    var variantId = $('form #ProductSelect-cdk-product-template').val();
    items.push({
      id: variantId,
      quantity: quantity
    });
  } else {
    console.log('elses  2');
    var variantId = $('form #ProductSelect-cdk-product-template option:selected').attr('data-discount-variant-id');
    items.push({
      id: variantId,
      quantity: quantity,
      "properties": {
        "shipping_interval_frequency": shipping_interval_frequency_value,
        "shipping_interval_unit_type": shipping__interval_unittype_value
      }
    });
  }
  subscriptionAjaxAddToCart(items, currentThis, redirectToCheckout);
});

$(document).on("click", "form .subscribe--product-addtocart", function (p) {
  p.preventDefault();
  var currentThis = $(this);
  currentThis.text("Please wait...");
  currentThis.addClass("make--me-untoucable");
  var quantity = parseInt($('.product-form__item .quantityInput #Quantity-cdk-product-template').val());
  var items = [];
  var redirectToCheckout = 'true';
  var shipping__interval_unittype_value = $('#rc_container input[name="properties[shipping_interval_unit_type]"]').val();
  var shipping_interval_frequency_value = $('#rc_container  select[name="properties[shipping_interval_frequency]"]').val();

  if ($('#rc_radio_options .rc_radio__onetime').is(":checked") || $('#rc_radio_options .rc_radio__onetime').length == 0) {
    var variantId = $('form #ProductSelect-cdk-product-template').val();
    items.push({
      id: variantId,
      quantity: quantity
    });
  } else {
    console.log('elses');
    var variantId = $('form #ProductSelect-cdk-product-template option:selected').attr('data-discount-variant-id');
    items.push({
      id: variantId,
      quantity: quantity,
      "properties": {
        "shipping_interval_frequency": shipping_interval_frequency_value,
        "shipping_interval_unit_type": shipping__interval_unittype_value
      }
    });
  }
  subscriptionAjaxAddToCart(items, currentThis, redirectToCheckout);
});

$(document).on("click", ".add-to_cart", function (p) {
  p.preventDefault();
  var currentThis = $(this);
  currentThis.text("Please wait...");
  var quantity = parseInt($(this).attr('data-item-quantity')),
    id = $(this).attr('data-varient-id');
  var variantId = id;
  cd_ajaxAddToCart(id, quantity).done(function (data) {
    var btnText = "ADD TO CART";
    //update_minicart(variantId,btnText);
    updateMiniCartContents(btnText);
  });
});

function update_cart(lineId, Qty, currentThis) {

  $.ajax({
    type: "POST",
    url: '/cart/change.js',
    data: {
      quantity: Qty,
      line: lineId
    },
    dataType: 'json',
    success: function (response) {
      var variantId = '';
      var btnText = '';
      update_minicart(variantId, btnText);
    }
  });
}

// SINGLE PRODUCT VARIANTS

function clean_value(data) {
  data = $.trim(data);
  return data;
}

function manage_select_box_variants(mainThis) {

  var variantOptionName = '';
  var count = 1;
  var totalSelector = mainThis.find('.dropdown-option--block').find('.cdk_selector-wrapper').length;
  mainThis.find('.dropdown-option--block').find('.cdk_selector-wrapper').each(function () {
    var selectorValue = clean_value($(this).find('.single-option-selector').val());
    if (count < totalSelector) {
      variantOptionName += selectorValue + ' / ';
    } else {
      variantOptionName += selectorValue;
    }
    count++;
  })
  variantOptionName = clean_value(variantOptionName);
  var variantId = mainThis.find('.product-variants-mainblock').find('.product-variants--block').find('option[data-variant-title="' + variantOptionName + '"]').attr('data-variant-id');
  var variantAvailability = mainThis.find('.product-variants-mainblock').find('.product-variants--block').find('option[data-variant-title="' + variantOptionName + '"]').attr('data-variant-availability');
  console.log('variantAvailability::' + variantAvailability);

  if (variantId == undefined || variantId == '') {
    mainThis.parents('.product-list').find('.cdk_btn').addClass('btn_disable').removeClass('add-to_cart').text('Unavailabel');
  } else {
    mainThis.parents('.product-list').find('.cdk_btn').addClass('add-to_cart').removeClass('btn_disable').text('Add To Cart');

    if (variantAvailability == 'false') {
      console.log('variantAvailability:: testfalse');
      mainThis.parents('.product-list').find('.cdk_btn').addClass('btn_disable').removeClass('add-to_cart').text('Sold Out');
    } else {
      mainThis.parents('.product-list').find('.cdk_btn').addClass('add-to_cart').removeClass('btn_disable').text('Add To Cart');
    }
  }
  mainThis.find('.product-variants-mainblock').find('.product-variants--block').find('select.product---variants-list').val(variantId).change();
}

function getVariantDetail(productData, variantId) {
  var variant = {};
  for (var v = 0; v < productData.variants.length; v++) {

    if (productData.variants[v].id == variantId) {
      variant = productData.variants[v];
    }
  }
  return variant;

}

function manage_product_details(mainThis, variantId) {
  mainThis.parents('.product-form-block').next('.cdk_btn').attr('data-varient-id', variantId);
  var productData = mainThis.parents('.product-variants-mainblock').find('.product--json-block').attr('data-product-json');
  let deserializedproductData = JSON.parse(clean_value(productData));
  getVariantDetail(deserializedproductData, variantId);
}

function checkPreOrder() {
  const prodItem = $('.cdk_product-item');

  prodItem.each(function () {
    const productTagsDiv = $(this).find('.product-tags'),
      productTags = productTagsDiv.attr('data-tags'),
      productAddButton = $(this).find('.add-to-cart-btn');

    if (productTags.includes('preorder')) {
      productAddButton.addClass('preorder');
      productAddButton.text('Pre Order');
    }
  });
}

// SINGLE PRODUCT VARIANTS
$(document).ready(function () {
  $(document).on("change", ".product-form-block .dropdown-option--block .cdk_selector-wrapper select", function () {
    var mainThis = $(this).parents('.product-form-block');
    manage_select_box_variants(mainThis);
  });

  $(document).on("change", ".product-form-block .product-variants--block .product---variants-list", function () {
    checkPreOrder();
    var mainThis = $(this);
    var variantId = $(this).val();
    manage_product_details(mainThis, variantId);
  });

  $(document).on("click", ".size_option_items div", function () {
    var dataValue = $(this).attr('var-data-value');
    console.log('dataValue::' + dataValue);
    $('.size_option_items div').removeClass('selected');
    $(this).addClass('selected');
    $('.sizeblock_main_select').val(dataValue).trigger('change');
  });

  $('body').on('click', '#shopify-section-cart-popup-new .cart .cart__quantity-td .quantity-left-minus', function () {
    var currentThis = $(this);
    var currentQty = parseInt($.trim($(this).parents('.input-group-btn').siblings('.cart__qty-input').val()));
    var lineId = $.trim($(this).parents('.input-group-btn').siblings('.cart__qty-input').attr('data-quantity-item'));
    if (currentQty > 0) {
      var requiredQty = currentQty - 1;
      $('#shopify-section-cart-popup-new .cart-popup-wrapper').LoadingOverlay("show");
      update_cart(lineId, requiredQty, currentThis);
    }
  });

  $('body').on('click', '#shopify-section-cart-popup-new .cart .cart__quantity-td .quantity-right-plus', function () {
    var currentThis = $(this);
    $('#shopify-section-cart-popup-new .cart-popup-wrapper').LoadingOverlay("show");
    var currentQty = parseInt($.trim($(this).parents('.input-group-btn').siblings('.cart__qty-input').val()));
    var lineId = $.trim($(this).parents('.input-group-btn').siblings('.cart__qty-input').attr('data-quantity-item'));
    if (currentQty <= 0) {
      currentQty = 1;
    } else {
      currentQty = currentQty + 1;
    }
    update_cart(lineId, currentQty, currentThis);
  });

  $('.product-details li:contains("Flavour:")').each(function () {
    $(this).html($(this).html().split("Flavour:").join(""));
  });
  $('.product-details li:contains("Size:")').each(function () {
    $(this).html($(this).html().split("Size:").join("x"));
  });

  $('body').on('change', '.product-form .product-form__controls-group .selector-wrapper > .single-option-selector', function () {
    var varient_combi_name = '';
    var zx = 1;
    var total_option_list = $(".product-form .product-form__controls-group .selector-wrapper").length;
    if (total_option_list > 1) {
      $(".product-form .product-form__controls-group .selector-wrapper").each(function () {
        var current_varient_value = $(this).find('.single-option-selector').val();
        if (zx < total_option_list) {
          varient_combi_name = varient_combi_name + current_varient_value + ' / ';
        } else {
          varient_combi_name = varient_combi_name + current_varient_value;
        }
        zx++;
      });

    } else {
      var varient_combi_name = $.trim($(this).val());
    }
    var varient__id_active = $(".product-form #ProductSelect-cdk-product-template option[data-title='" + varient_combi_name + "']").val();
    $(".product-form #ProductSelect-cdk-product-template").val(varient__id_active).change();
  })

  $('body').on('click', '.product-form #product--subscribe_btn-11', function () {
    var currentThis = $(this);
    currentThis.text("Please wait...");
    currentThis.addClass("make--me-untoucable");
    var quantity = parseInt($.trim($(this).parents('form').find('.quantityInput').find('#Quantity-cdk-product-template').val()));
    var id = $.trim($(this).parents('form').find('#ProductSelect-cdk-product-template').val());

    $('#shopify-section-cart-popup-new .cart-popup-wrapper').LoadingOverlay("show");
    ajaxAddToCart(id, quantity).done(function (data) {
      var variantId = id;
      var btnText = 'SUBSCRIBE';
      update_minicart(variantId, btnText);
    });

  });

})

$(document).ready(function () {
  var screenWidth = $(window).width();
  if (screenWidth < 975) {
    var headerHeight = $('#shopify-section-header').height();
    $('body').css('padding-top', headerHeight + 'px');
    console.log('screenWidth::' + screenWidth);
  }

  $(document).on('click', '.accordion_item label:not(.active)', function () {
    $('.accordion_item .accordion_content').slideUp();
    $('.accordion_item label').removeClass('active');
    $(this).addClass('active');
    $(this).next('.accordion_content').slideDown();
  })

  $(document).on('click', '.accordion_item label.active', function () {
    $(this).removeClass('active');
    $(this).next('.accordion_content').slideUp();
  })

  $('#rc_radio_options .rc_block__type').click(function () {
    $('#rc_radio_options .rc_block__type').removeClass('rc_block__type--active');
    $(this).addClass('rc_block__type--active');

    if ($('#rc_radio_options .rc_radio__autodeliver').is(":checked")) {
      $('.subscribe--product-addtocart').show();
    } else {
      $('.subscribe--product-addtocart').hide();
    }
  })

  $('#rc_radio_options .rc_block__type').removeClass('rc_block__type--active');
  $('#rc_radio_options .rc_block__type input:checked').parents('.rc_block__type').addClass('rc_block__type--active');
  if ($('#rc_radio_options .rc_radio__autodeliver').is(":checked")) {
    $('.subscribe--product-addtocart').show();
  } else {
    $('.subscribe--product-addtocart').hide();
  }

  // on page load

  var varient_combi_name = '';
  var zx = 1;
  var total_option_list = $(".product-form .product-form__controls-group .selector-wrapper").length;
  if (total_option_list > 0) {
    $(".product-form .product-form__controls-group .selector-wrapper").each(function () {
      var current_varient_value = $(this).find('.single-option-selector').val();
      if (zx < total_option_list) {
        varient_combi_name = varient_combi_name + current_varient_value + ' / ';
      } else {
        varient_combi_name = varient_combi_name + current_varient_value;
      }
      zx++;
    });

    var varient__id_active = $(".product-form #ProductSelect-cdk-product-template option[data-title='" + varient_combi_name + "']").val();
    $(".product-form #ProductSelect-cdk-product-template").val(varient__id_active).change();

  }

  var mapVariant = $.trim($('#rc_container #rc_variant_map_data_json_format').text());
  // console.log('mapVariant :: '+mapVariant);
  if (mapVariant != '') {
    var mapVariant = mapVariant.replace(/=>/g, ':');
    //  console.log('mapVariant :: '+mapVariant);
    mapVariant = JSON.parse(mapVariant);

    $('form #ProductSelect-cdk-product-template option').each(function () {
      var variantId = $(this).val();
      var discountVariantId = mapVariant.original_to_hidden_variant_map[variantId].discount_variant_id;
      //    console.log('discountVariantId :: '+discountVariantId);
      $(this).attr('data-discount-variant-id', discountVariantId);
    })
  }

  $('body').on('click', '.cart__submit-controls .cart__submit.btn--small-wide', function () {
    var isSubscribeProductExist = '';
    reChargeProcessCart(isSubscribeProductExist);
  });

  $(document).on('click', '.cart-popup__dismiss-button, .cdk_mob_header_btn', function () {
    console.log('click: Fire');
    $('.cart-popup-wrapper').addClass('cart-popup-wrapper--hidden');
  })
  $(document).on('click', '.cdk_cart_header_btn', function () {
    $('.mobile-nav--close').trigger('click');
  })
}); 

/* Kit jquery code */

$(function () {
  // Update kit total price.
  window.updateKitPrice = function () {
    var _kit_total = 0;
    $('.kit-prod').each(function () {
      _kit_total += parseInt($(this).find('.j-price').html().replace('£', ''));
    });
    $('.kit-cta .total-price').html(_kit_total);
    $('.kit-cta .discounted-price').html((_kit_total * .80).toFixed(2));
  }

  updateKitPrice();
});


$(document).on('change', '.kit-part-variant-id', function () {
  console.log("data");
  // recalculate pricing for bundle parts and discounted value
  var totalPrice = 0;
  $(this).closest('.product-overview').find('.kit-part-variant-id option:selected').each(function () {
    totalPrice += $(this).data('price');
  });

  $(this).closest('.product-overview').find('.total-price').text(totalPrice);
  $(this).closest('.product-overview').find('.discounted-price').text(totalPrice);
  $('.in-your-kit').find('.total-price').text(totalPrice);
  $('.in-your-kit').find('.discounted-price').text(totalPrice);

});

$('.kit-part-variant-id').trigger('change');

$('.product-tile .quantity select').change(function () {
  $this = $(this);
  $product = $(this).parents('.product-tile');
  var _variant = $product.find('.buy-btn:visible').data('variant');

  var _unit_price = $this.val() * parseFloat($product.find('.product-variants span[data-variant=' + _variant + ']').data('price').replace('Â£', ''));

  $product.find('.buy-btn:visible .j-price').html('Â£' + _unit_price);

});

// Update price depending on the variants selected.
$('.selector-wrapper').each(function () {
  // Update the variant price where multiple variant options are present
  var $product = $(this).parents('.product-tile');
  if ($(this).hasClass('multiple')) {
    $(this).find('select').each(function () {
      var $parent = $(this).parents('.variant-dropdown');
      var $this = $(this);
      console.log("here");
      $(this).change(function () {
        var combined = '';
        $parent.find('select').each(function () {
          combined += $(this).val();
        });

        let hasUpdated = false;

        $parent.siblings('.product-variants').find('>span').each(function () {
          $this = $(this);
          if ($(this).data('title') == combined) {
            hasUpdated = true;
            $product.find('.j-price').html('Â£' + $product.find('.quantity select').val() * parseFloat($this.data('price').replace('Â£', '')));
            $product.find('.variant_id').val($this.data('variant'));
            $product.find('.buy-btn').hide();
            $product.find('.buy-btn[data-variant=' + $this.data('variant') + ']').show();
            $product.find('.availability-strip').hide();
            $product.find('.availability-strip[data-id=' + $this.data('variant') + ']').show();
            if ($('.kit-cta').length) {
              updateKitPrice();
            }
          }
        });

        if (hasUpdated) {
          console.log('has updated');
        } else {
          $product.find('.buy-btn').hide();
          $product.find('.buy-btn.not_available').show();
        }
      })

    });
    // Update the variant price where single variant option is present
  } else {
    var $this = $(this);
    $this.find('select').change(function () {
      $product.find('.variant_id').val($(this).val());
      $product.find('.buy-btn').hide();
      $product.find('.buy-btn[data-variant=' + $(this).val() + ']').show();
      $product.find('.availability-strip').hide();
      $product.find('.availability-strip[data-id="' + $(this).val() + '"]').show();
      if ($('.kit-cta').length) {
        updateKitPrice();
      }
    });
  };
});

// Auto update and open cart side drawer for 3 seconds.
$(document).on('cart.requestComplete', function (event, cart) {
  window.cart = cart;
  if (cart.item_count > 0) {
    $('.cart-count, .cart-trigger').html('CART (<span>' + cart.item_count + '</span>)');
  } else {
    $('.cart-count, .cart-trigger').text('CART');
  }

  $(".checkout-wrap").load("/ .checkout-wrap .content", function () {
    resizeCart();
    $('.checkout-wrap').addClass('open');
    updateMultiBuy();
    $('body').addClass('no-scroll');
    $('.body-overlay').addClass('cart').stop(true, true).fadeIn('fast');
  });
});


function updateMultiBuy() {
  var cart_count = window.cart.item_count;
  var $percentage = $('.checkout-wrap .current-discount .percentage');
  var $discount_bar = $('.checkout-wrap .discount-bar .progress');
  var $you_save_msg = $('.checkout-wrap .you-save');

  $you_save_msg.hide();
  $discount_bar.hide();
  $discount_bar.find('.max').hide();
  window.cart_applied_discount = 0;

  if (cart_count == 1) {
    $percentage.html(10);
    $discount_bar.find('.num').html(10);
    $discount_bar.css({
      'width': '0'
    });
    $you_save_msg.css({
      'display': 'none'
    });
    window.cart_applied_discount = 0;
  } else if (cart_count == 2) {
    $percentage.html(20);
    $discount_bar.find('.num').html(10);
    $discount_bar.show().css({
      'width': '33.33%'
    });
    $you_save_msg.css({
      'display': 'inline-block'
    });
    $you_save_msg.find('.num').html(10);
    window.cart_applied_discount = 10;
  } else if (cart_count == 3) {
    $percentage.html(30);
    $discount_bar.find('.num').html(20);
    $discount_bar.show().css({
      'width': '66.66%'
    });
    $you_save_msg.css({
      'display': 'inline-block'
    });
    $you_save_msg.find('.num').html(20);
    window.cart_applied_discount = 20;
  } else if (cart_count >= 4) {
    $percentage.html(40);
    $you_save_msg.css({
      'display': 'inline-block'
    });
    $you_save_msg.find('.num').html(30);
    $('.checkout-wrap .current-discount').html('You qualify for <strong><span class="percentage">30</span>% off</strong> your total order');
    $discount_bar.show().css({
      'width': '100%',
      'border-radius': '0'
    }).end().find('.num').html(30).end().find('.max').show();

    window.cart_applied_discount = 30;
  }

  $('#cart_calculated_total').text(((window.cart.total_price - (window.cart.total_price / 100 * window.cart_applied_discount)) / 100).toFixed(2));
  $('.j-cart-checkout').attr('href', '/checkout?discount=multibuy' + window.cart_applied_discount);

  if (cart_count > 1) {
    $('.item').each(function () {
      var item_price = $(this).find('.j-price').data('price');
      var discount_price = ((item_price - (item_price / 100 * window.cart_applied_discount)) / 100);
      $(this).find('.j-price').addClass('strikethrough');
      $(this).find('.price').addClass('multiple');
      $(this).find('.j-update-price').parent().show();
      $(this).find('.j-update-price').text(discount_price);
    });
  }
}

function quantityItemChange(variant_id, value, addProduct, new_variant_id, quantity) {
  //convert string to int
  var variant_id = parseInt(variant_id);

  //ajax get request to cart.js
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + value + '&id=' + variant_id,
    dataType: 'json',
    complete: function (data) {
      location.reload();
    },
    error: function (XMLHttpRequest) {
      var response = eval('(' + XMLHttpRequest.responseText + ')');
      response = response.description;
    }
  });
}

function cartItemQuantityVariant() {
  var cartItem = $('.cart__row');
  var cartQuantity = $('.product-quantity');

  cartQuantity.each(function () {

    var quantitySelect = $(this).find('.product-quantity-select'),
      quantityValue = $(this).find('.product-quantity-value').attr('value'),
      quantityInput = $(this).find('.product-quantity-value');

    //On initial load, set the dropdown to reflect the current quantity.	
    quantitySelect.find('[value="' + quantityValue + '"]').attr('selected', true);

    // LM Once quantity has been changed, need to update input value beneath so checkout quanity is updated as well.
    quantitySelect.on('change', function () {
      var selectedValue = $(this).find(':selected').attr('value');
      var selectedInput = $(this).next();

      $(selectedInput).attr('value', selectedValue);
    });

  });

  cartItem.each(function () {
    var quantitySelect = $(this).find('.product-quantity-select'),
      quantitySelectValue = quantitySelect.val();

    quantitySelect.on('change', function () {
      quantitySelectValue = $(this).val();
      quantitySelectId = quantitySelect.attr('data-variant-id');

      quantityItemChange(quantitySelectId, quantitySelectValue);
    })
  });
}

if ($('body').hasClass('template-cart')) {
  cartItemQuantityVariant();
}
